import { useMemo } from 'react';
import { slidersData } from './Materials.sliders';

export function useMaterialSliders(material?: IMaterial) {
  const output = useMemo(() => {
    slidersData[0].items = slidersData[0].items.map((item: any) => {
      const { id } = item;

      const defaultValue = item.defaultValue;
      const value = ((material as any) ?? {})[id] ?? defaultValue;

      return {
        ...item,
        value,
      };
    });
    return slidersData;
  }, [material]);

  return output;
}
